const keyMirror = require('keymirror');
import { getCookie, isUserLogin } from '../lib/tool';

const Types = keyMirror({
    SET_SESSION: null,
    RETSET_SESSION: null,
    SET_SESSION_ERROR: null,
    SET_STATUS: null,
    SET_JUST_LOGIN: null
});
const Types_Status = keyMirror({
    FETCHED: null,
    NOT_FETCHED: null,
    FETCHING: null
});
const initialState = {
    status: Types_Status.NOT_FETCHED,
    session: {},
    justLogined: false
}

const reducer = (state, action) => {
    // Reducer for handling changes to session state
    const justLogined = localStorage.getItem('justLogined');
    if (typeof state === 'undefined') {
        state = {
            ...initialState,
            justLogined
        };
    }
    switch (action.type) {
        case Types.SET_SESSION:
            const user = { ...action.session, username: action.session.fname }
            return { ...state, session: { user } };
        case Types.RETSET_SESSION:
            return { ...state, session: action.session };
        case Types.SET_STATUS:
            return { ...state, status: action.status };
        case Types.SET_JUST_LOGIN:
            return { ...state, justLogined: action.justLogined }
        case Types.SET_SESSION_ERROR:
            // TODO: do something with action.error
            return state;
        default:
            return state;
    }
};

const isJustLogined = boolean => {
    localStorage.setItem('justLogined', boolean);
    return {
        type: Types.SET_JUST_LOGIN,
        justLogined: boolean
    }
}


const setSessionError = error => ({
    type: Types.SET_SESSION_ERROR,
    error: error
});

const setSession = session => ({
    type: Types.SET_SESSION,
    session: session
});

const resetSession = session => ({
    type: Types.RETSET_SESSION,
    session: session
})

const setStatus = status => ({
    type: Types.SET_STATUS,
    status: status
});

const refreshSession = dispatch => {
    dispatch(setStatus(Types_Status.FETCHING));
    if (isUserLogin()) {
        let session = getCookie("l_p_cc_0");
        dispatch(setSession(JSON.parse(decodeURIComponent(session))));
        dispatch(setStatus(Types_Status.FETCHED));
    } else {
        dispatch(resetSession({}));
        dispatch(setStatus(Types_Status.FETCHED));
    }
};

export {
    reducer as default,
    initialState as userInitialState,
    setSessionError,
    setSession,
    setStatus,
    refreshSession,
    isJustLogined,
    resetSession
}
